import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString, createCommentVNode, createBlock, unref, withCtx, createVNode, createTextVNode, mergeProps } from "vue";
import { CdrButton, IconArrowUp } from "@rei/cedar";
import BuyBoxAddToCart from "../BuyBox/BuyBoxAddToCart/BuyBoxAddToCart.mjs";
const _hoisted_1 = {
  class: "atc-sticky"
};
const _hoisted_2 = {
  class: "atc-sticky__img-and-title"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "atc-sticky__title"
};
const _hoisted_5 = {
  class: "atc-sticky__attributes-and-btn"
};
const _hoisted_6 = {
  class: "atc-sticky__attributes"
};
const _hoisted_7 = {
  key: 0,
  class: "atc-sticky__attribute"
};
const _hoisted_8 = {
  class: "atc-sticky__attribute-label"
};
const _hoisted_9 = {
  key: 1,
  class: "atc-sticky__attribute"
};
const _hoisted_10 = {
  class: "atc-sticky__attribute-label"
};
const _hoisted_11 = {
  key: 2,
  class: "atc-sticky__attribute"
};
const _hoisted_12 = {
  class: "atc-sticky__attribute-label"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AddToCartSticky",
  props: {
    addToCartButtonProps: {},
    brandName: {
      default: ""
    },
    color: {
      default: ""
    },
    colorLabel: {
      default: ""
    },
    fulfillmentLabel: {
      default: ""
    },
    fulfillmentLocation: {
      default: ""
    },
    imageSrc: {
      default: "/media/00000000-0000-0000-0000-000000000000"
    },
    size: {
      default: ""
    },
    sizeLabel: {
      default: ""
    },
    productTitle: {},
    validationText: {
      default: ""
    }
  },
  emits: ["addToCart", "metricsClick", "selectOptions"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleATCStickySelectOptions = () => {
      emit("selectOptions");
      emit("metricsClick", {
        linkName: "sticky_select options"
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createElementVNode("img", {
        class: "atc-sticky__image",
        src: _ctx.imageSrc,
        alt: ""
      }, null, 8, _hoisted_3), createElementVNode("div", _hoisted_4, toDisplayString(_ctx.brandName) + " " + toDisplayString(_ctx.productTitle), 1)]), createElementVNode("div", _hoisted_5, [createElementVNode("div", _hoisted_6, [_ctx.color ? (openBlock(), createElementBlock("div", _hoisted_7, [createElementVNode("span", _hoisted_8, toDisplayString(_ctx.colorLabel) + ":", 1), createElementVNode("span", {
        ref: "color"
      }, toDisplayString(_ctx.color), 513)])) : createCommentVNode("", true), _ctx.size ? (openBlock(), createElementBlock("div", _hoisted_9, [createElementVNode("span", _hoisted_10, toDisplayString(_ctx.sizeLabel) + ":", 1), createElementVNode("span", {
        ref: "size"
      }, toDisplayString(_ctx.size), 513)])) : createCommentVNode("", true), _ctx.fulfillmentLocation ? (openBlock(), createElementBlock("div", _hoisted_11, [createElementVNode("span", _hoisted_12, toDisplayString(_ctx.fulfillmentLabel), 1), createElementVNode("span", {
        ref: "location"
      }, toDisplayString(_ctx.fulfillmentLocation), 513)])) : createCommentVNode("", true)]), _ctx.validationText ? (openBlock(), createBlock(unref(CdrButton), {
        key: 0,
        modifier: "secondary",
        class: "atc-sticky__atcBtn",
        onClick: handleATCStickySelectOptions
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconArrowUp), {
          "inherit-color": ""
        })]),
        default: withCtx(() => [createTextVNode(" " + toDisplayString(_ctx.validationText), 1)]),
        _: 1
      })) : (openBlock(), createBlock(unref(BuyBoxAddToCart), mergeProps({
        key: 1,
        id: "add-to-cart-sticky-button",
        class: "atc-sticky__atcBtn"
      }, _ctx.addToCartButtonProps, {
        onAddToCart: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("addToCart", "add to cart_sticky"))
      }), null, 16))])]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AddToCartSticky2.mjs.map
